<script setup>
import { computed, useSlots, defineProps } from 'vue'

defineProps({
  label: {
    type: String,
    default: null
  },
  help: {
    type: String,
    default: null
  }
})

const slots = useSlots()

const wrapperClass = computed(() => {
  const base = []
  const slotsLength = slots.default().length

  if (slotsLength > 1) {
    base.push('grid grid-cols-1 gap-3')
  }

  if (slotsLength === 2) {
    base.push('md:grid-cols-2')
  }

  return base
})
</script>

<template>
  <div class="mb-2 last:mb-0">
    <label
      v-if="label"
      class="block font-bold text-xs mb-1"
    >{{ label }}</label>
    <div :class="wrapperClass">
      <slot />
    </div>
    <div
      v-if="help"
      class="text-xs text-red-500 mt-1"
    >
      {{ help }}
    </div>
  </div>
</template>
